<template>
    <transition-group name="comment-list" tag="main">
        <CommentPost v-for="comment in comments" :key="comment.id" :comment="comment" />
    </transition-group> 
</template>

<script>
import CommentPost from './CommentPost.vue';

export default {
    components: {
        CommentPost,
    },
    computed: {
        comments() {
            return this.$store.state.comments;
        },
    },
}
</script>

<style lang="scss">
@import '../../scss/settings';

    // Transition
    .comment-list-move {
        transition: transform .4s ease-out;
    }
    .comment-list {
        transition: all .4s ease-out;
    }
    .comment-list-enter-active,
    .comment-list-leave-active {
        transition: all .4s;
    }
    .comment-list-enter,
    .comment-list-leave-to {
        opacity: .05;
        transform: translateX(-50px);
    }

</style>